/********** DATATABLE **********/

export const GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT = "GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT"
export const GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_OK = "GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_OK"
export const GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_ERR = "GET_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_ERR"
export const DO_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_CLEANUP = "DO_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_CLEANUP"

/********** DATATABLE FILTERS **********/

export const APPLY_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_FILTERS = "APPLY_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_FILTERS"
export const CLEAR_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_FILTERS = "CLEAR_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_FILTERS"
export const DO_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_FILTERS_CLEANUP = "DO_SUBSCRIPTION_CANCELLATION_REQUESTS_DT_FILTERS_CLEANUP"

